module.exports = __webpack_public_path__ + "img/stream-placeholder.919958e6.svg";